import { useMemo } from "react";

import { EmailType } from "@interfaces/campaign.type";

import { handleFuzzySort } from "@utilities/handleFuzzySort";

interface ICompanyFilters {
  [key: number]: (email: any) => boolean;
}

const useEmailFilters = (emails: EmailType[], searchQuery: string) => {
  const filters: ICompanyFilters = useMemo(
    () => ({
      0: () => true,
      1: (email) => email.status.opened > 0,
      2: (email) => email.status.clicked > 0,
      3: (email) => email.status.responded > 0,
      4: (email) => email.status.lead === true,
      5: (email) => email.status.bounced === true,
    }),
    [],
  );

  return useMemo(() => {
    return (index: number) => {
      const filterFunction = filters[index] || (() => true);
      const filteredEmails = emails.filter(filterFunction);

      if (searchQuery) {
        return handleFuzzySort(searchQuery, filteredEmails, { keys: ["name", "email", "company.name"] });
      }

      return filteredEmails;
    };
  }, [emails, searchQuery, filters]);
};

export default useEmailFilters;
